"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _mapcDuotone = _interopRequireDefault(require("../assets/images/mapc-duotone.svg"));

var _mapcSemitransparent = _interopRequireDefault(require("../assets/images/mapc-semitransparent.svg"));

var _mapcFullcolor = _interopRequireDefault(require("../assets/images/mapc-fullcolor.png"));

var logoData = {
  duotone: _mapcDuotone.default,
  semitransparent: _mapcSemitransparent.default,
  fullcolor: _mapcFullcolor.default
};

var Logo = function Logo(_ref) {
  var style = _ref.style,
      props = (0, _objectWithoutProperties2.default)(_ref, ["style"]);
  return /*#__PURE__*/React.createElement("img", Object.assign({
    src: logoData[style],
    alt: "MAPC Logo"
  }, props));
};

exports.Logo = Logo;